import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteJournalEntryRequestForm.FieldsSection', {
    journalEntryDetailsSectionTitle: 'Journal Entry Details',
    memoSectionTitle: 'Memo',
    textFieldPlaceholder: 'Enter value',
    dateFieldPlaceholder: 'Select date',
    transactionReferenceFieldText: 'Reference',
    transactionDateFieldText: 'Date',
    reversalDateFieldText: 'Reversal date',
    classFieldText: 'Class',
    classFieldPlaceholder: 'Select class',
    departmentFieldText: 'Department',
    departmentFieldPlaceholder: 'Select department',
    locationFieldText: 'Location',
    locationFieldPlaceholder: 'Select location',
    postingPeriodFieldText: 'Posting period',
    reversalDeferFieldText: 'Reversal defer',
    reversalDeferFieldLabel: 'Yes',
});
